module.exports = __webpack_public_path__ + "img/fdalogo.d663c9e9.png";